"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _twilioActionKeys = require("../constants/twilioActionKeys");
var _twilioServices = require("../services/twilioServices");
var _reduxActions = require("redux-actions");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var _default = exports["default"] = _objectSpread({}, (0, _reduxActions.createActions)((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, _twilioActionKeys.GET_CLIENT, function (serviceProviderId, userId) {
  return {
    promise: (0, _twilioServices.getClient)(serviceProviderId, userId)
  };
}), _twilioActionKeys.GET_MESSAGES, function (client, sid, pageSize) {
  return {
    promise: (0, _twilioServices.getMessages)(client, sid, pageSize)
  };
}), _twilioActionKeys.SEND_MESSAGE, function (client, conversationSid, message, serviceProviderId, browser) {
  return {
    promise: (0, _twilioServices.sendMessage)(client, conversationSid, message, serviceProviderId, browser)
  };
}), _twilioActionKeys.GET_PREVIOUS_MESSAGES, function (client, sid, index, pageSize) {
  return {
    promise: (0, _twilioServices.getPreviousMessages)(client, sid, index, pageSize)
  };
}), _twilioActionKeys.SET_ALL_MESSAGES_READ, function (client, sid) {
  return {
    promise: (0, _twilioServices.setAllMessagesRead)(client, sid)
  };
})));
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/lead-ion/lib/common/actions/twilioActions.js
// module id = 2409
// module chunks = 25